var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4663 30.251V26.801",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.2491V23.3491",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5337 30.2495V19.8828",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.533 9.74918L27.7663 10.6492C23.5163 15.6158 17.8163 19.1325 11.4663 20.7158",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6499 9.74918H28.5332V14.6158",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 36.666H24.9997C33.333 36.666 36.6663 33.3326 36.6663 24.9993V14.9993C36.6663 6.66597 33.333 3.33264 24.9997 3.33264H14.9997C6.66634 3.33264 3.33301 6.66597 3.33301 14.9993V24.9993C3.33301 33.3326 6.66634 36.666 14.9997 36.666Z",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUpBlack);
export default __webpack_public_path__ + "static/media/status-up-black.8424d451a4d4d13419d887eb87f055bb.svg";
export { ForwardRef as ReactComponent };